module.exports = __webpack_public_path__ + "img/Picture5.a46b2254.jpg";